// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logo__root--wQy2h {
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
}

    .Logo__root--wQy2h img {
        width: 172px;
        height: 40px;
    }

`, "",{"version":3,"sources":["webpack://./src/components/Logo/Logo.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AAMd;;IAJI;QACI,YAAY;QACZ,YAAY;IAChB","sourcesContent":[".root {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n\n    & img {\n        width: 172px;\n        height: 40px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Logo__root--wQy2h`
};
export default ___CSS_LOADER_EXPORT___;
